module.exports = __webpack_public_path__ + "static/img/demo_profile.d1808de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/demo_profile.png
// module id = KRZM
// module chunks = 31